import { useFeatureFlagValue } from "@shared/services/posthog/use-feature-flag";

export const DEFAULT_MAX_CSV_CONTACTS = 5000;
const MAX_CSV_CONTACTS_UPPER_BOUND = 25000;

export function resolveCsvContactsLimit(
  flagValue: number | boolean | string | null,
): number {
  if (
    typeof flagValue !== "number" ||
    flagValue < DEFAULT_MAX_CSV_CONTACTS ||
    flagValue > MAX_CSV_CONTACTS_UPPER_BOUND
  ) {
    return DEFAULT_MAX_CSV_CONTACTS;
  }

  return flagValue;
}

export const useCsvContactsImportLimit = (): number => {
  const flagValue = useFeatureFlagValue("radar-contacts-csv-import-limit");
  return resolveCsvContactsLimit(flagValue);
};
